import { request } from '@umijs/max';

/**
 * Fetch current user profile information
 */
export async function fetchCurrentUser() {
  return request('/user/api/currentUser', {
    method: 'GET',
  });
}

/**
 * Fetch current user's subscription and credits information
 */
export async function fetchCurrentPlan() {
  return request('/user/current-plan', {
    method: 'GET',
  });
}

/**
 * Update user profile information
 */
export async function updateUserProfile(params: {
  fullName: string;
  phoneNumber: string;
}) {
  return request('/user/update-profile', {
    method: 'POST',
    data: params,
  });
}

/**
 * Change user password
 */
export async function changePassword(params: {
  currentPassword: string;
  newPassword: string;
}) {
  return request('/user/change-password', {
    method: 'PUT',
    data: params,
  });
}

/**
 * Fetch excluded marketers list
 */
export async function fetchExcludedMarketers() {
  return request('/data/get_excluded_marketers', {
    method: 'GET',
  });
}

/**
 * Update excluded marketers list
 */
export async function addExcludedMarketers(params: {
  marketerIds: number[];
}) {
  return request('/data/add_excluded_marketers', {
    method: 'POST',
    data: params,
  });
}

export async function removeExcludedMarketers(params: {
  marketerId: number;
}) {
  return request('/data/remove_excluded_marketers', {
    method: 'DELETE',
    data: params,
  });
}

/**
 * Fetch excluded manufacturers list
 */
export async function fetchExcludedManufacturers() {
  return request('/data/get_excluded_manufacturers', {
    method: 'GET',
  });
}

/**
 * Update excluded manufacturers list
 */
export async function addExcludedManufacturers(params: {
  manufacturerIds: number[];
}) {
  return request('/data/add_excluded_manufacturers', {
    method: 'POST',
    data: params,
  });
}

export async function removeExcludedManufacturers(params: {
  manufacturerId: number;
}) {
  return request('/data/remove_excluded_manufacturers', {
    method: 'DELETE',
    data: params,
  });
}